import { calc, cssVar, cssVariables } from '@hover/blueprint';

/**
 * The gap between images in the history stack, which is applied via a
 * transparent border so that we can `translateX()` the images in multiples of
 * 100% while preserving the gap.
 */
export const $imageGap = cssVar('customize-history-image-gap');
export const imagePadding = calc.divide($imageGap, 2);
export const $imageBorderRadius = cssVariables.radius(300);

export const $paddingX = cssVar('customize-history-padding-x');

export const $arrowDistance = cssVar('customize-history-arrow-distance');
